






































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";
import { InitiativeStrategyMatrixGoal } from "@/interfaces";

@Component
export default class InitiativeStrategyMatrixDialog extends Vue {
  @Ref("new-survey-address-dialog")
  dialog!: QDialog;

  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: Object, required: true })
  item!: InitiativeStrategyMatrixGoal;

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
